/**
 * @module Components.Onboarding
 *
 */
export { default as Wrapper } from './Wrapper';
export { default as Footer } from './Footer';
export { default as Strike } from './Strike';
